import React from 'react';
import {
  Box,
  Container,
  makeStyles,
} from '@material-ui/core';

import Page from 'src/components/Page';
import View from './View';

import PageHeader from '../../components/PageHeader';
import ListAltIcon from '@material-ui/icons/ListAlt';

const useStyles = makeStyles((theme) => ({
  root: {
    background: '#f7f7fa',
    minHeight: '100%',
    paddingBottom: theme.spacing(4),
    paddingTop: theme.spacing(3),
  },
}));

const AuctionListView = () => {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="List Auctions"
    >
      <Container maxWidth="lg">

        <PageHeader
          icon={<ListAltIcon />}
          title="Auction List"
          subtitle="View and manage auctions"
          showSession
        />

        <Box mt={3}>
          <View />
        </Box>

      </Container>
    </Page>
  );
};

export default AuctionListView;